module.exports = __webpack_public_path__ + "static/media/preAssessment.69d6f32b.png";